import useEffectOnce from './use-effect-once'

const useUnmount = (fn: () => void | undefined) => useEffectOnce(() => fn)

export default useUnmount
